import React from 'react';
import { SessionData, ConnectionStatus } from '../types';
import { formatTimeframe } from '../utils/timeframe';
import { getBrokerTimezoneName } from '../utils/timezone';

interface StatusBarProps {
  sessionData: SessionData;
  connectionStatus: ConnectionStatus;
  tradesCount: number;
}

const StatusBar: React.FC<StatusBarProps> = ({
  sessionData,
  connectionStatus,
  tradesCount
}) => {
  const getStatusColor = () => {
    switch (connectionStatus) {
      case 'connected':
        return '#4caf50';
      case 'connecting':
        return '#ff9800';
      case 'disconnected':
        return '#f44336';
      default:
        return '#9e9e9e';
    }
  };

  const getStatusText = () => {
    switch (connectionStatus) {
      case 'connected':
        return 'Connected';
      case 'connecting':
        return 'Connecting...';
      case 'disconnected':
        return 'Disconnected';
      default:
        return 'Unknown';
    }
  };

  const formatLastUpdate = () => {
    const lastUpdate = new Date(sessionData.last_update);
    const now = new Date();
    const diffMs = now.getTime() - lastUpdate.getTime();
    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);

    if (diffSeconds < 60) {
      return `${diffSeconds}s ago`;
    } else if (diffMinutes < 60) {
      return `${diffMinutes}m ago`;
    } else {
      return lastUpdate.toLocaleTimeString();
    }
  };

  return (
    <div className="chart-header">
      <div className="chart-title">
        EEFX Chart - {sessionData.symbol} ({formatTimeframe(sessionData.timeframe)}) - {getBrokerTimezoneName()}
      </div>
      
      <div className="chart-status">
        <div className="status-item">
          <span className="status-label">Session:</span>
          <span className="status-value">{sessionData.session_name}</span>
        </div>
        
        <div className="status-item">
          <span className="status-label">Trades:</span>
          <span className="status-value">{tradesCount}</span>
        </div>
        
        <div className="status-item">
          <span className="status-label">Last Update:</span>
          <span className="status-value">{formatLastUpdate()}</span>
        </div>
        
        <div className="connection-status">
          <div 
            className={`status-indicator ${connectionStatus}`}
            style={{ backgroundColor: getStatusColor() }}
          />
          <span className="status-text">{getStatusText()}</span>
        </div>
      </div>
    </div>
  );
};

export default StatusBar;